var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwardArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32937 0.144001C4.29267 0.0995898 4.24356 0.0632782 4.18628 0.0381923C4.129 0.0131068 4.06525 0 4.00054 0C3.93583 0 3.87209 0.0131068 3.8148 0.0381923C3.75752 0.0632782 3.70842 0.0995898 3.67172 0.144001L0.071434 4.47704C0.0297608 4.52701 0.00532293 4.58555 0.00077486 4.64629C-0.00377274 4.70703 0.0117431 4.76764 0.0456381 4.82155C0.0795326 4.87545 0.130509 4.92059 0.193029 4.95205C0.25555 4.98351 0.327222 5.0001 0.40026 5H7.60082C7.67369 4.99975 7.7451 4.98295 7.80737 4.95142C7.86964 4.91988 7.92041 4.8748 7.95422 4.82101C7.98804 4.76723 8.00362 4.70679 7.99929 4.64618C7.99496 4.58557 7.97088 4.52709 7.92965 4.47704L4.32937 0.144001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrowDark);
export default __webpack_public_path__ + "static/media/upward_arrow_dark.f1c7380d9ad7e3087c655d2b74492fde.svg";
export { ForwardRef as ReactComponent };